import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiService {

    constructor() { }

    getUrl() {
        return environment.api.baseUrl;
    }

    getAwsGatewayToken(): string {
        return environment.apiKey;
    }

    getRedirectUrl() {
        return environment.paths.loginPortal;
    }
}

export const ApiVersion = environment.api.ApiVersion;
